import React from 'react';
import { Switch } from 'react-router-dom';
import {
  HomeScreen,
  LogoutScreen,
  ProfileScreen,
  ManageAppScreen,
  SearchScreen,
  GroupScreen,
  SecuredRoute,
  IntegrationScreen,
  FolderScreen,
  SettingsScreen,
  AuditScreen,
} from 'screens';
import { AppLayout, NavigationBar, Interstitial } from 'components';
import { SubscriptionPlaygroundScreen } from 'services/apollo/playground';

export const AppRouter = () => {
  return (
    <Interstitial>
      <NavigationBar />
      <AppLayout>
        <Switch>
          <SecuredRoute exact path={'/profile/:userId'} component={ProfileScreen} />
          <SecuredRoute exact path={'/manage-apps'} component={ManageAppScreen} />
          <SecuredRoute path={'/search/:qs'} component={SearchScreen} />
          <SecuredRoute exact path={'/group/:groupId'} component={GroupScreen} />
          <SecuredRoute exact path={'/folder/:folderId'} component={FolderScreen} />
          <SecuredRoute exact path={'/settings'} component={SettingsScreen} />
          <SecuredRoute exact path={'/dsa'} component={AuditScreen} />
          <SecuredRoute exact path={'/dsa/outside-organization'} component={AuditScreen} />
          <SecuredRoute exact path={'/dsa/personal-accounts'} component={AuditScreen} />
          <SecuredRoute exact path={'/dsa/outside-ownership'} component={AuditScreen} />
          <SecuredRoute exact path={'/dsa/open-links'} component={AuditScreen} />
          <SecuredRoute exact path={'/dsa'} component={AuditScreen} />
          <SecuredRoute
            exact
            path={'/integration/:integrationType'}
            component={IntegrationScreen}
          />
          <SecuredRoute exact path="/logout" component={LogoutScreen} />
          <SecuredRoute
            exact
            path={'/subscription-playground'}
            component={SubscriptionPlaygroundScreen}
          />
          <SecuredRoute path="/" component={HomeScreen} />
        </Switch>
      </AppLayout>
    </Interstitial>
  );
};
